import { getTsCustomerPortalClient } from '@montugroup/circuit-shared/api/customer-portal.client';

const client = getTsCustomerPortalClient();

/**
 * The useResendEscriptSignupInvite hook interfaces with the resendEscriptSignupInvite contract to allow the front end to send a POST request to the endpoint
 *
 * @returns mutate, isPending
 */
export function useResendEscriptSignupInvite() {
  const { mutate, isPending } = client.resendEscriptSignupInvite.useMutation();

  return {
    mutate,
    isPending,
  };
}
